module.exports = __webpack_public_path__ + "03_long_gold.2716d486.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/03_long_gold.png
// module id = tUae
// module chunks = 0